import {
  Box, Grid,
} from '@mui/material';
import { useContext } from 'react';
import EditableText from '../../Form/EditableText';
import CloseButton from '../../Buttons/Close';
import Utils from '../../../utils/Utils';
import BlockProps from '../../../models/BlockProps';
import ImageComponent from '../../ImageComponent';
import { ImagesContext } from '../../../contexts/ImagesContext';
import BlockImageAndTextData from './BlockImageAndTextData';
import ImageModal from '../../Modals/ImageModal/ImageModal';

function BlockImageAndText({
  data, isEditing, isTemplate, editHandler,
}: BlockProps) {
  const props = (data.data as BlockImageAndTextData);
  const { images } = useContext(ImagesContext);
  const handleTitleUpdate = (text?: string) => {
    props.title.value = text;
    editHandler(data.id, props);
  };

  const handleDescriptionUpdate = (text?: string) => {
    props.description.value = text;
    editHandler(data.id, props);
  };

  const deleteImage = () => {
    props.mainImage = undefined;
    editHandler(data.id, props);
  };

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        minHeight: '250px',
        overflow: 'hidden',
        backgroundImage: props.backgroundImage ? `url(${props.backgroundImage})` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {(isEditing && !isTemplate) && (
        <ImageModal
          title="背景設定"
          images={images}
          handleOnConfirm={(url: string) => {
            editHandler(data.id, props);
          }}
        />
      )}

      <Grid
        item
        xs={12}
        sx={{
          marginTop: 8,
        }}
      />

      {props.title && (
        <Grid
          item
          xs={12}
          sx={{
            position: 'relative',
            mx: 2,
          }}
        >
          <Box sx={Utils.hoverBorder(isEditing)}>

            {isEditing && (
              <CloseButton updateHandler={() => {
                props.title = undefined;
                editHandler(data.id, props);
              }}
              />
            )}

            <EditableText
              text={props.title.value}
              isEditable={isEditing && !isTemplate}
              updateHandler={handleTitleUpdate}
            />
          </Box>
        </Grid>
      )}

      <Grid
        container
        spacing={0}
        direction="row"
        alignItems="stretch"
        justifyContent="space-between"
      >
        <Grid
          item
          xs={4}
          sx={{
            position: 'relative',
            my: 5,
            paddingLeft: 8,
          }}
        >
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            sx={{
              height: 1,
            }}
          >

            {props.mainImage && (
              <Box sx={Utils.hoverBorder(isEditing)}>

                {isEditing && <CloseButton updateHandler={() => { deleteImage(); }} />}

                <label htmlFor={`${data.id}_main`}>
                  <ImageModal
                    disabled={isTemplate || !isEditing}
                    images={images}
                    handleOnConfirm={(url: string) => {
                      props.mainImage.value = url;
                      editHandler(data.id, props);
                    }}
                  >
                    <ImageComponent src={props.mainImage.value} />
                  </ImageModal>
                </label>
              </Box>
            )}

          </Grid>
        </Grid>

        {props.description && (
          <Grid
            item
            xs={7}
            sx={Utils.hoverBorder(isEditing, {
              my: 5, mx: 2,
            })}
          >

            {isEditing && (
              <CloseButton updateHandler={() => {
                props.description = undefined;
                editHandler(data.id, props);
              }}
              />
            )}

            <EditableText
              text={props.description.value}
              isEditable={isEditing && !isTemplate}
              updateHandler={handleDescriptionUpdate}
            />

          </Grid>
        )}

      </Grid>

    </Grid>
  );
}

export default BlockImageAndText;
